import { createTheme } from '@mui/material/styles';

// Central font constant — used by MUI and mirrored to CSS via index.js
export const FONT_FAMILY = "'PT sans', 'Yeseva One', serif";

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#ed5034',
        },
        background: {
            default: '#fbfbfb',
            paper: '#ffffff',
        },
        text: {
            primary: '#111827',
            secondary: '#6b7280',
        },
    },
    typography: {
        fontFamily: FONT_FAMILY,
        h1: {
            fontFamily: FONT_FAMILY,
            fontWeight: 700,
            fontSize: '3rem',
        },
        h2: {
            fontFamily: FONT_FAMILY,
            fontWeight: 700,
            fontSize: '2.25rem',
        },
        h3: {
            fontFamily: FONT_FAMILY,
            fontWeight: 600,
        },
        button: {
            textTransform: 'none',
            fontWeight: 700,
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiAppBar: {
            defaultProps: {
                elevation: 0,
            },
        },
    },
});

export default theme;
